import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useRepairHistoryModel } from "../repairHistoryModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";

export const DataBox = () => {
    const {
        repairHistoryExport
    } = useRepairHistoryModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.STT_RH_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { repairHistoryExport() }}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}